import { useCallback, useEffect, useRef, useState } from "react";
import { CrossIcon } from "../../components/icons/Icon";
import SlidingFilter2 from "../../components/updatedComponents/Dealers/SlidingFilter2";
import styles from "./Marketing2.module.css";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import Button from "../../components/updatedComponents/Dealers/Button";
import { CreateTem } from "../../components/icons/Icon2";
import fetchData from "../../APIsControll/apiControll";
import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";

const CreateLeadPopUp = ({ mode, close, managerId, getLeads }) => {
  const { show } = useToast();
  const pinCodeRef = useRef(null);
  const [selectedFilter, setSelectedFilter] = useState("Wholesale");
  const [userData, setUserData] = useState({
    managerId: managerId,
    name: "",
    mobile: "",
    pincode: "",
    city: "",
    district: "",
    state: "",
    country: "India",
    storeName: "",
    source: "admin",
    status: "New",
    // type: selectedFilter.toLowerCase(),
  });
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);

  const createLead = async () => {
    const payload = {
      ...userData,
      type: selectedFilter.toLowerCase(),
    };
    setSaveLoading(true);
    try {
      const res = await fetchData("leads/createLead", payload);

      if (res.status === "success") {
        show(res.msg, "success");
        setSaveLoading(false);
        close();
        getLeads();
      }

      if (res.status === "failed") {
        setSaveLoading(false);
        show(res.msg, "error");
      }
    } catch (error) {
      setSaveLoading(false);
      console.error(error);
    }
  };

  const getLocation = useCallback(async () => {
    setLoading(true);
    setErrorMsg("");
    try {
      const apiData = {
        keyword: userData.pincode,
      };
      const result = await fetchData("locations/locations", apiData);
      if (result.status === "success") {
        setLoading(false);
        setUserData((prevState) => ({
          ...prevState,
          city: result.SubDistName[0]
            ? result.SubDistName[0].toUpperCase()
            : "",
          district: result.districts[0] ? result.districts[0] : "",
          state: result.states[0] ? result.states[0] : "",
        }));
        setErrorMsg("");
        if (
          result.SubDistName.length === 0 ||
          result.districts.length === 0 ||
          result.states[0].length === 0
        ) {
          setErrorMsg("No such Pincode exists!");
          pinCodeRef.current?.focus();
        }
      }
    } catch (error) {
      setLoading(false);
      pinCodeRef.current?.focus();
      setErrorMsg(error);
    } finally {
      setLoading(false);
    }
  }, [userData.pincode]);

  useEffect(() => {
    if (userData.pincode.length === 6) {
      getLocation();
    }
  }, [getLocation, userData.pincode.length]);

  const filterChange = (v) => {
    const selectedFilter = filters.find((d) => d === v);
    const newFilter = selectedFilter || "Wholesale";
    setSelectedFilter(newFilter);
    setFormErrors({});
  };

  const validateForm = () => {
    const errors = {};

    if (!userData.name.trim()) {
      errors.name = "Name is required";
    }

    if (!userData.mobile.trim()) {
      errors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(userData.mobile)) {
      errors.mobile = "Mobile number must be 10 digits";
    }

    if (selectedFilter === "Wholesale") {
      if (!userData.storeName.trim()) {
        errors.storeName = "Company name is required";
      }
    }

    if (!userData.pincode.trim()) {
      errors.pincode = "Pin code is required";
    } else if (!/^\d{6}$/.test(userData.pincode)) {
      errors.pincode = "Pin code must be 6 digits";
    }

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    createLead();
  };

  const filters = ["Wholesale", "Retail"];

  return (
    <div
      className={styles.create_lead_modal}
      style={{ backgroundColor: mode && "#2C2E33" }}
    >
      <div className={styles.create_lead_header}>
        <p style={{ color: mode && "#FFFFFF" }}>Create Lead</p>
        <div onClick={close}>
          <CrossIcon color={mode ? "#FFFFFF" : "#000000"} />
        </div>
      </div>

      <div className={styles.filter_con}>
        <SlidingFilter2
          itemList={filters}
          selectedItem={selectedFilter}
          setFilter={filterChange}
        />
      </div>

      <form
        action="/submit"
        method="post"
        className={styles.form}
        onSubmit={handleSubmit}
      >
        <div className={styles.element}>
          <InputTag
            name="name"
            value={userData.name}
            labelText={"Name"}
            placeholderText={"Enter name"}
            placeholderType={"text"}
            required={true}
            star
            maxLength={100}
            onChange={(e) => {
              setUserData((prev) => ({
                ...prev,
                name: e.target.value,
              }));
            }}
            padding={"8px"}
            fontSize={"12px"}
          />
          {formErrors.name && (
            <span className={styles.error_text}>{formErrors.name}</span>
          )}
        </div>

        <div className={styles.element}>
          <InputTag
            name="mobile"
            value={userData.mobile}
            labelText={"Mobile Number"}
            placeholderText={"Enter mobile number"}
            placeholderType={"number"}
            required={true}
            star
            maxLength={10}
            onChange={(e) => {
              setUserData((prev) => ({
                ...prev,
                mobile: e.target.value,
              }));
            }}
            padding={"8px"}
            fontSize={"12px"}
          />{" "}
          {formErrors.mobile && (
            <span className={styles.error_text}>{formErrors.mobile}</span>
          )}
        </div>

        {selectedFilter === "Wholesale" && (
          <div className={styles.element}>
            <InputTag
              name="storeName"
              value={userData.storeName}
              labelText={"Company name"}
              placeholderText={"Enter company name"}
              placeholderType={"text"}
              required={selectedFilter === "Wholesale" && true}
              star
              maxLength={100}
              onChange={(e) => {
                setUserData((prev) => ({
                  ...prev,
                  storeName: e.target.value,
                }));
              }}
              padding={"8px"}
              fontSize={"12px"}
            />{" "}
            {formErrors.storeName && (
              <span className={styles.error_text}>{formErrors.storeName}</span>
            )}
          </div>
        )}

        <div className={styles.element}>
          <InputTag
            name="pincode"
            value={userData.pincode}
            labelText={"Pin Code"}
            placeholderText={"Enter pin code"}
            placeholderType={"number"}
            required={true}
            star
            maxLength={6}
            onChange={(e) => {
              setUserData((prev) => ({
                ...prev,
                pincode: e.target.value,
              }));
            }}
            padding={"8px"}
            fontSize={"12px"}
          />{" "}
          {formErrors.pincode && (
            <span className={styles.error_text}>{formErrors.pincode}</span>
          )}
          <div className={styles.txt_con}>
            {errorMsg.length !== 0 ? (
              <p style={{ color: "#F93E39" }}>{errorMsg}</p>
            ) : loading ? (
              <Spinner
                height={20}
                width={20}
                color={mode ? "#000000" : "#4164E3"}
              />
            ) : userData.city.length === 0 ||
              userData.district.length === 0 ||
              userData.state.length === 0 ? (
              <p style={{ color: mode ? "#FFFFFF" : "#646B88" }}>
                CITY / DISTRICT / STATE
              </p>
            ) : (
              <p style={{ color: mode ? "#FFFFFF" : "#646B88" }}>
                {userData.city} / {userData.district} / {userData.state}
              </p>
            )}
          </div>
        </div>

        <div className={styles.create_lead_header} style={{ gap: "10px" }}>
          <Button
            buttonText={"Close"}
            buttonIcon={<CrossIcon color={"#FFFFFF"} />}
            buttonBgColor={"#000000"}
            buttonTextColor={"#FFFFFF"}
            buttonClick={close}
          />
          <Button
            buttonText={"Add"}
            buttonIcon={<CreateTem />}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#FFFFFF"}
            buttonType={"submit"}
            buttonClick={handleSubmit}
            disabled={loading || saveLoading}
            loading={saveLoading}
          />
        </div>
      </form>
    </div>
  );
};

export default CreateLeadPopUp;
